import { gql } from '@apollo/client';
import {
  useListChapterCommentQuery as useQuery,
  ListChapterCommentQueryVariables,
} from './__generated__/useListChapterComment.generated';

export const CHAPTER_COMMENT = gql`
  fragment CommentItem on ChapterComment {
    createdAt
    ccId
    story {
      name
      storyId
    }
    chapter {
      name
      chapterId
      chapterIndex
    }
    author {
      name
      userId
    }
    authorId
    isHidden
    isSpoiler
    content
    numOfLikes
    numOfNestedComments
    contentEditedAt
    deletedAt
    deletedByAdmin
    isBestComment
    likedByMe
    parentId
  }
`;

export const LIST_CHAPTER_COMMENT = gql`
  query ListChapterComment(
    $storyId: Int!
    $chapterIndex: Int
    $parentId: Int
    $choiceId: Int
    $page: Int!
    $pageSize: Int
    $exceptHidden: Boolean
    $exceptDeleted: Boolean
    $orderBy: [ChapterCommentOrderBy!]
    $onlySystemLanguageMatched: Boolean
  ) {
    listChapterCommentV3(
      data: {
        storyId: $storyId
        chapterIndex: $chapterIndex
        parentId: $parentId
        choiceId: $choiceId
        page: $page
        pageSize: $pageSize
        exceptHidden: $exceptHidden
        exceptDeleted: $exceptDeleted
        orderBy: $orderBy
        onlySystemLanguageMatched: $onlySystemLanguageMatched
      }
    ) {
      page
      totalCount
      canWriteComment
      list {
        ...CommentItem
      }
    }
  }
  ${CHAPTER_COMMENT}
`;

export const useListChapterComment = (
  variables: ListChapterCommentQueryVariables,
) => {
  const { data, loading, fetchMore, networkStatus, refetch } = useQuery({
    variables,
    skip: isNaN(Number(variables.storyId)),
    notifyOnNetworkStatusChange: true,
  });

  return { data, loading, fetchMore, networkStatus, refetch };
};
